export default __webpack_public_path__ + "static/media/2.6907f0a2.jpg";